import axiosInstance from "../backend/axiosInstance";

export const TeamIcons = {};
export const TeamIconsMeta = {};

let fetched = false;

export async function fetchTeamIcons() {
  if (fetched) return;
  fetched = true;

  try {
    const response = await axiosInstance.get("/team-logos/");

    response.data.forEach((item) => {
      TeamIcons[item.teamTag] = item.link;

      TeamIconsMeta[item.teamTag] = {
        link: item.link,
        dark: item.dark,
      };
    });
  } catch (error) {
    console.error("Error fetching team logos:", error);
  }
}

export function TeamIconComponent({ team }) {
  return (
    <img
      src={TeamIcons[team]}
      style={{
        filter: TeamIconsMeta[team]?.dark ? "invert(1)" : "none"
      }}
      alt={team}
      className="small-image"
    />
  );
}